import React from "react";

const TimeoutContext = React.createContext(() => {});

export default TimeoutContext;
